import RoleBasedComponent from "./RoleOnlyComponent";
export default RoleBasedComponent;
export * from "./RoleOnlyComponent";
